export default "__VITE_ASSET__CQJDTBMa__"